module.exports = __webpack_public_path__ + "static/media/ski.66833b33.jpg";